jQuery(document).ready(function ($) {
  /* IE popup
  ========================================================================== */

  checkIfIE();

  function checkIfIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      alert(
        "For an optimal viewing experience, please choose a different browser."
      );
    }

    return false;
  }

  /* Set VW without horizontal scrollbar
  ========================================================================== */

  setVw();
  function setVw() {
    var vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty("--vw", "".concat(vw, "px"));
  }

  window.addEventListener("resize", function (params) {
    setVw();
  });

  /* Home header animation
  ========================================================================== */

  gsap.registerPlugin(ScrollTrigger);

  if ($(".fade-up").length) {
    gsap.utils.toArray(".fade-up").forEach((item, i) => {
      gsap.from(item, {
        scrollTrigger: {
          trigger: item,
          start: "center bottom",
        },
        y: "+=150",
        opacity: 0,
      });
    });
  }

  if ($(".home").length) {
    let tlHomeHeaderBtns = gsap.timeline({
      defaults: {
        y: "+=200",
        delay: 0.5,
        opacity: 0,
        duration: 0.7,
      },
    });

    $(".home-header__left-btn").each((index, element) => {
      tlHomeHeaderBtns.from(
        element,
        {
          scrollTrigger: {
            trigger: element,
            start: "center bottom",
          },
        },
        "<20%"
      );
    });

    gsap.to(".lower-leg", {
      // selector text, Array, or object
      rotation: -45,
      duration: 1.2,
      repeat: -1,
      yoyo: true,
      transformOrigin: "5% 20%",
      ease: "none",
    });

    gsap.to(".left-arm", {
      // selector text, Array, or object
      rotation: -25,
      duration: 1.2,
      repeat: -1,
      yoyo: true,
      transformOrigin: "60% left",
      ease: "none",
    });

    let tlServiceItems = gsap.timeline({
      scrollTrigger: {
        trigger: ".home-services",
        start: "center bottom",
      },
      defaults: {
        y: "+=150",
        delay: 0.3,
        opacity: 0,
        duration: 0.7,
      },
    });

    $(".home-services__services-item").each(function (index, element) {
      tlServiceItems.from(element, {}, "<10%");
    });

    tlServiceItems.from(
      ".home-services__btn-container",
      {
        delay: 0,
        duration: 0.5,
      },
      ">-30%"
    );
  }

  /* Services details
  ========================================================================== */

  $(".service__more-btn").on("click", function () {
    $(this)
      .next(".service__details")
      .addClass("active")
      .css("display", "flex")
      .hide()
      .fadeIn();

    $("body").css("overflow-y", "hidden");
  });

  $(document).on("click", ".service__details-close", function () {
    $(".service__details.active").removeClass("active").fadeOut();
    $("body").css("overflow-y", "unset");
  });

  $(document).on("click", ".service__details.active", function (event) {
    if (this == event.target) {
      $(".service__details.active").removeClass("active").fadeOut();
      $("body").css("overflow-y", "unset");
    }
  });

  /* Accordion
  ========================================================================== */

  $(".accordion").on("click", function () {
    let acc = this;

    if (!$(acc).hasClass("active")) {
      $(acc)
        .siblings(".active")
        .toggleClass("active")
        .next(".panel")
        .slideToggle();
    }

    $(acc).toggleClass("active").next(".panel").slideToggle();
  });

  /* Team member view more button
  ========================================================================== */

  $(".team-member__more-btn").on("click", function () {
    $(this).text($(this).text() === "View More" ? "View Less" : "View More");

    $(this)
      .next(".team-member__separator")
      .slideToggle()
      .next(".team-member__biography")
      .slideToggle();
  });

  /* Google maps
  ========================================================================== */

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create generic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
      keyboardShortcuts: false,
      fullscreenControl: false,
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#dff0fe",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              color: "#60b4f8",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#4a8dd4",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#eff8fe",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#dff0fe",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c7eaff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#27a5ee",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#bbe6ff",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#b6e4ff",
            },
          ],
        },
      ],
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: "/wp-content/uploads/2022/01/marker.svg",
        scaledSize: new google.maps.Size(45, 60),
      },
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function () {
    $(".contact-map").each(function () {
      var map = initMap($(this));
    });
  });
});
